import { useEffect } from "react";

import { useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";

import { selectAdvanced, selectIsXRayActive, selectPicker, selectPoints } from "../renderSlice";
import { Picker } from "../types";

export function useHandleAdvancedSettings() {
    const {
        state: { view },
    } = useExplorerGlobals();
    const settings = useAppSelector(selectAdvanced);
    const pointSize = useAppSelector(selectPoints).size;
    const picker = useAppSelector(selectPicker);
    const isXRayActive = useAppSelector(selectIsXRayActive);

    useEffect(() => {
        if (!view) {
            return;
        }

        const sectionPlanePickerActive = picker === Picker.SectionPlane;
        let toonOutline;
        if (isXRayActive) {
            toonOutline = {
                ...settings.toonOutline,
                enabled: false,
                on: false,
                outlineObjects: false,
            };
        } else if (sectionPlanePickerActive) {
            toonOutline = { ...settings.toonOutline, enabled: true, on: true, outlineObjects: true };
        } else {
            toonOutline = { ...settings.toonOutline, on: false };
        }

        view.modifyRenderState({
            output: {
                samplesMSAA: settings.msaa.enabled ? settings.msaa.samples : 0,
            },
            toonOutline,
            tonemapping: settings.tonemapping,
            pick: settings.pick,
            debug: settings.debug,
            outlines: { breakingPointAngleThreshold: settings.outlines.breakingPointAngleThreshold },
        });
    }, [view, settings, picker, isXRayActive]);

    useEffect(() => {
        if (!view) {
            return;
        }

        view.modifyRenderState({
            points: {
                size: pointSize,
            },
        });
    }, [view, pointSize]);
}
